// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore, Timestamp } from 'firebase/firestore'; // <--- MODIFIED: Added Timestamp
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage'; // Uncomment if you add image upload to Firebase Storage later

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize storage, uncomment if needed later

// Export the initialized services
export { db, auth, storage, Timestamp }; // <--- MODIFIED: Added Timestamp to export